import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { findDashboardLeaf } from '@cumlaude/shared-dashboard-registry';
import { stripQueryParams } from '@cumlaude/shared-services';
import { FilteringTekstService } from '../../../services/filtering-tekst.service';

@Component({
	selector: 'app-pagina-samenvatting',
	templateUrl: './pagina-samenvatting.component.html',
	styleUrls: ['./pagina-samenvatting.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginaSamenvattingComponent {
	private readonly filteringTekstService = inject(FilteringTekstService);

	url = input.required<string>();
	titel = input<string>();

	private readonly pad = computed(() => stripQueryParams(this.url()));
	private readonly leaf = computed(() => findDashboardLeaf(this.pad()));

	weergaveTitel = computed(() => this.titel() ?? this.leaf()?.titel ?? '');
	hoofdpagina = computed(() => this.leaf()?.hoofdpagina);
	filteringTekst = computed(() => this.filteringTekstService.bepaalFilteringTekst(this.url()));
}
